// @ts-nocheck
import environmentConfig from "constants/config";

const API_URL = `${environmentConfig.ADMIN.apiHost}/client-log`;

function sendLog(level, messages) {
  try {
    fetch(API_URL, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        level,
        messages,
        url: window.location.href,
        userAgent: navigator.userAgent,
        timestamp: new Date().toISOString(),
      }),
    });
  } catch (err) {
    // Avoid infinite loop if logging fails
    console.warn("Failed to send client log", err);
  }
}

export const setupClientLogger = () => {
  const originalConsole = window.console;

  const customConsole = {
    log: (...msg) => {
      originalConsole.log(...msg);
      //sendLog("log", msg);
    },
    table: (...msg) => {
      originalConsole.table(...msg);
      //sendLog("log", msg);
    },
    info: (...msg) => {
      originalConsole.info(...msg);
      //sendLog("info", msg);
    },
    warn: (...msg) => {
      originalConsole.warn(...msg);
      //sendLog("warn", msg);
    },
    error: (...msg) => {
      originalConsole.error(...msg);
      sendLog("error", msg);
    },
  };

  window.console = customConsole;
};